import { CheckoutState } from '../../state';
import { getShouldShowCalendarSelection } from '../app/getShouldShowCalendarSelection';
import { isSeriesParent as getIsSeriesParent } from '../event';

export const getSeriesSelectionType = (state: CheckoutState) => {
    const isSeriesParent = getIsSeriesParent(state);
    const shouldShowCalendarSelection = getShouldShowCalendarSelection(state);
    return isSeriesParent
        ? {
              seriesSelectionType: shouldShowCalendarSelection
                  ? 'CalendarSelection'
                  : 'ListSelection',
          }
        : {};
};
